module.exports = __webpack_public_path__ + "img/flag-tnt.d0e61e44.png";